<section class="endContract" fxLayout="column" fxLayoutAlign="start start">

    <div>
        <p>{{keyTranslate + '.payText' | translate}}</p>
        <div class="payInfo" (click)="InfoPayDialog()">
            <mat-icon>info_outlined</mat-icon>
            <span class="popup-info">{{keyTranslate + '.popupText' | translate}}</span>
        </div>
    </div>

    <form class="form" [formGroup]="invoiceForm">
        <div class="form-field">
            <label class="form-label" for="factura">
                {{keyTranslate + '.label.invoice' | translate}}
            </label>

            <input 
                class="form-input" 
                id="factura"
                type="text"
                formControlName="factura"
            >

            <div *ngIf="factura.invalid && (factura.dirty || factura.touched)" class="errorForm">
                {{keyTranslate + '.label.validations.isEmpty' | translate}}
            </div>
        </div>
    </form>

</section>